module.exports = __webpack_public_path__ + "img/coupon_stamp-effect.d960f095.png";